module.exports = __webpack_public_path__ + "img/w5-cover.c1b124ea.jpg";